module.exports = __webpack_public_path__ + "static/ContinuousImprovement-53a8f6c5135c2318d0b0ee9b1023222f.png";